import { VocabularyTerms } from '@ftr/contracts/type/core'
import indefinite from 'indefinite'

export class DuplicateCourthouseName extends Error {
  constructor(terms: VocabularyTerms) {
    super(`${indefinite(terms.courthouse.singular.toLowerCase(), { capitalize: true })} with that name already exists.`)
    Object.setPrototypeOf(this, DuplicateCourthouseName.prototype)
  }
}
